<template>
    <nav class="section-nav" :class="rootClasses" ref="nav">
        <div class="section-nav--displacer">
            <!-- <div style="position: fixed; left: 0; top: 0; background: white; width: 100%; z-index: 10000" v-text="boundaries"></div> -->
            <div class="section-nav--root" :style="listStyles" v-if="isVisible">
                <cmp-accordion :is-active="isFreeFloating || isAffixedBottom" :passive-mode="true" v-if="titleSection">
                    <div slot="body" class="section-nav--title" v-html="titleSection.title"></div>
                </cmp-accordion>
                <ol class="u-reset section-nav--items">
                    <li v-for="(section, sectionIdx) in sortedSections"
                            class="section-nav--item"
                            :class="activePosition === section.position ? (bemRoot + '--item__is-active') : ''">
                        <a :href="'#' + section.content.anchor" class="u-reset section-nav--anchor-link">
                            <!-- <span class="section-nav--text" v-text="section.boundaries" style="position: absolute;"></span> -->
                            <span class="section-nav--text" v-text="section.content.menu_title"></span>
                            <span class="section-nav--rail">
                                <span class="section-nav--bg">
                                    <span class="section-nav--bullet"></span>
                                </span>
                            </span>
                        </a>
                    </li>
                </ol>
            </div>
        </div>
    </nav>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import bemMixin from 'vue/mixins/bem';
    import isMountedMixin from 'vue/mixins/is-mounted';
    import viewportBoundariesMixin from 'vue/mixins/viewport-boundaries';


    export default {
        DEBUG: true,
        mixins: [
            bemMixin('section-nav'),
            isMountedMixin,
            viewportBoundariesMixin,
        ],
        computed: {
            ...mapGetters(['sections', 'titleSection', 'viewport', 'scroll']),
            sortedSections() {
                return this.sections.sort((a, b) => {
                    return a.position - b.position;
                });
            },
            isAffixedTop() {
                if (!this.hasVisibleSections) {
                    return false;
                }

                const { top } = this.boundaries.el;
                return top.isAfter.vp.top;
            },
            isAffixedBottom() {
                if (!this.hasVisibleSections) {
                    return false;
                }

                const { top, bottom } = this.boundaries.el;
                return top.isBefore.vp.top && bottom.isWithin.vp;
            },
            isFreeFloating() {
                if (!this.hasVisibleSections) {
                    return false;
                }

                const { top, bottom } = this.boundaries.el;
                return top.isBefore.vp.top && bottom.isAfter.vp.bottom;
            },
            isVisible() {
                return this.isMounted && this.sections.length > 1 && toNumeral(this.viewport.mq.query) > numerals.MD;
            },
            hasVisibleSections() {
                return this.isVisible && !!this.sections.length;
            },
            visibleSections() {
                const fullyVisibleSections = [];
                const fullyFilledSections = [];
                const cutOffBottomSections = [];
                const cutOffTopSections = [];

                this.sections.forEach((section) => {
                    let targetArr;
                    const el = section.boundaries.el;

                    switch (true) {
                        case (el.isWithin.vp.fully):
                            targetArr = fullyVisibleSections;
                            break;
                        case (el.top.isBefore.vp.top && el.bottom.isAfter.vp.bottom):
                            targetArr = fullyFilledSections;
                            break;
                        case (el.top.isBefore.vp.bottom && el.bottom.isAfter.vp.bottom):
                            targetArr = cutOffBottomSections;
                            break;
                        case (el.top.isBefore.vp.top && el.bottom.isAfter.vp.top):
                            targetArr = cutOffTopSections;
                            break;
                        default:
                            targetArr = [];
                            break;
                    }

                    targetArr.push(section);
                });

                const result = [fullyVisibleSections, fullyFilledSections, cutOffBottomSections, cutOffTopSections]
                        .find(arr => arr.length) || [];

                return result;
            },
            activePosition() {
                if (!this.isVisible || !this.visibleSections.length) {
                    return -1;
                }

                // NOTE: Use smarter algorythm to favour sections according to scroll progress
                // Unfortunately when clicking on an item, the active nav doesn't correspond with the current section...
                //const sectionChoice = Math.round((this.visibleSections.length - 1) * this.scroll.progress);

                return this.visibleSections[0].position;
            },
            rootClasses() {
                if (!this.hasVisibleSections) {
                    return [];
                }

                return [
                    this.bemIf(this.isAffixedTop, 'is-affixed-top'),
                    this.bemIf(this.isAffixedBottom, 'is-affixed-bottom'),
                    this.bemIf(this.isFreeFloating, 'is-free'),
                ];
            },
            listStyles() {
                if (!this.isVisible || !this.viewport.mq.width) {
                    return {};
                }

                return {
                    width: `${ this.$refs.nav.clientWidth }px`,
                };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?24bf68b0